import { render, staticRenderFns } from "./bFooterView.vue?vue&type=template&id=5e0e1a74&scoped=true"
import script from "./bFooterView.vue?vue&type=script&lang=js"
export * from "./bFooterView.vue?vue&type=script&lang=js"
import style0 from "./bFooterView.vue?vue&type=style&index=0&id=5e0e1a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0e1a74",
  null
  
)

export default component.exports